import {
	APP_CONF_VARS as APP_CONF_VARS_GLOBAL,
	InterfaceAppConfVars,
} from './vars.conf';

export const APP_CONF_VARS: InterfaceAppConfVars = {
	...APP_CONF_VARS_GLOBAL,
};
